/* eslint-disable jsx-a11y/anchor-is-valid */
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import classNames from "classnames";
import actions from "src/store/auth/actions";
import useFormatById from "src/hooks/utils/useFormatById";
import AuthorizationPassword from "./authorization-password";
import AuthorizationCode from "./authorization-code";
import Identomat from "./identomat";
import PersonalNumberLogin from "./personalNumberLogin";

const LoginFormReworked = ({ isIdentomat }) => {
  const dispath = useDispatch();
  const formatMessage = useFormatById();
  const loginError = useSelector((state) => state.auth?.loginError);
  const checkUserObj = useSelector((state) => state.auth?.checkUserObj);

  const progressBarModel = [
    {
      progressNumber: 1,
      progressName: formatMessage("pin"),
      isActive: true,
    },
    {
      progressNumber: 2,
      progressName: formatMessage("smsAuth"),
      isActive: false,
    },
    {
      progressNumber: 3,
      progressName: formatMessage("new-password"),
      isActive: false,
    },
  ];
  const [progressBarArr, setProgressBarArr] = useState(progressBarModel);

  const [pId, setPId] = useState(localStorage.getItem("usr") || "");
  const [password, setPassword] = useState("");
  const isValid = true;

  const [isPersonalNumber, setIsPersonalNumber] = useState(true);
  const [isPasswordAuth, setIsPasswordAuth] = useState(false);
  const [isPasswordRecover, setIsPasswordRecover] = useState(false);
  const [loginWithCode, setLoginWithCode] = useState(false);

  const changeLogIn = () => {
    setIsPasswordAuth((prev) => !prev);
    setLoginWithCode(false);
    dispath(actions.setCheckuser({}));
  };
  useEffect(() => {
    dispath(actions.setLoginRequest(0));
  }, [isPasswordAuth]);
  return (
    <>
      {isIdentomat && <Identomat />}
      {!isIdentomat && (
        <div
          className={
            classNames(!isValid && "was-validated") +
            " d-flex flex-column align-items-center container"
          }
          autoComplete="off"
        >
          <div className="d-md-block d-none authorization-header p-md-5 p-4">
            {!isPasswordRecover
              ? checkUserObj?.isRegistered === false
                ? formatMessage("registration")
                : formatMessage("auth")
              : formatMessage("recover-pass")}
          </div>
          {isPasswordRecover && (
            <div
              className="recover-password-progress mb-4 text-center d-md-block d-none"
              style={{
                maxWidth: "586px",
                width: "100%",
              }}
            >
              <div className="row">
                {progressBarArr.map((item, index) => (
                  <div
                    className="col-4 progress-container"
                    key={item.progressNumber}
                  >
                    <div
                      className={
                        "progress-circle mx-auto mb-2" +
                        (item.isActive ? " is-active" : " ")
                      }
                    >
                      {item.progressNumber}
                    </div>
                    {index < progressBarArr.length - 1 && (
                      <div className="progress-line"></div>
                    )}
                    {item.progressName}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="login-container mx-auto p-md-5 p-3 mt-md-0 mt-4">
            <div className="d-block d-md-none authorization-header mb-5">
              {!isPasswordRecover
                ? checkUserObj?.isRegistered === false
                  ? formatMessage("registration")
                  : formatMessage("auth")
                : formatMessage("recover-pass")}
            </div>
            <div className="mb-3">
              <div className="form-floating pb-1">
                <input
                  type="text"
                  className={
                    "form-control loginInput" +
                    (loginError === "407" ? " error-input-style" : "")
                  }
                  id="floatingInput"
                  value={pId}
                  placeholder="Input"
                  onChange={(e) => setPId(e.target.value)}
                  autoComplete="off"
                  autoFocus
                  disabled={loginWithCode}
                />
                <label htmlFor="floatingInput" style={{ color: "#424244" }}>
                  {formatMessage("pin")}
                </label>
              </div>
              {loginError === "407" ||
              (!checkUserObj?.isClient &&
                !checkUserObj?.isRegistered &&
                checkUserObj?.maskedMobile === null) ? (
                <span className="error-text-style">
                  {formatMessage("cant-find-policy")}
                </span>
              ) : (
                ""
              )}
            </div>
            {isPersonalNumber && (
              <PersonalNumberLogin
                nextText={formatMessage("next")}
                {...{ pId, setIsPasswordAuth, setIsPersonalNumber }}
              />
            )}
            {isPasswordAuth && !isPasswordRecover && (
              <AuthorizationPassword
                {...{
                  pId,
                  setPId,
                  password,
                  setPassword,
                  loginError,
                  setIsPasswordRecover,
                  isPasswordAuth,
                }}
              />
            )}
            {(!isPasswordAuth || isPasswordRecover) && !isPersonalNumber && (
              <AuthorizationCode
                {...{
                  pId,
                  isPasswordRecover,
                  setIsPasswordRecover,
                  setProgressBarArr,
                  setLoginWithCode,
                  loginWithCode,
                  setIsPersonalNumber,
                }}
              />
            )}
            {!isPersonalNumber && !isPasswordRecover && (
              <div className="justify-content-center d-flex align-items-center">
                <span className="create-account-link mt-3 me-2">
                  {checkUserObj?.isRegistered === false &&
                    formatMessage("have-account")}{" "}
                </span>
                <div
                  className="code-authorization-link text-center mt-3"
                  onClick={() => changeLogIn()}
                >
                  {isPasswordAuth
                    ? formatMessage("auth-regis-code")
                    : formatMessage("passwrod-auth")}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default LoginFormReworked;
